import type { CSSObject } from 'styled-components';
import { maxWidth } from './counterTokens';
import type { StyledCounterProps } from './types';
import getIn from '~utils/lodashButBetter/get';
import { makeSize } from '~utils/makeSize';
import { makeBorderSize } from '~utils/makeBorderSize';

const getStyledCounterStyles = ({
  theme,
  platform,
  backgroundColor,
}: StyledCounterProps): CSSObject => ({
  backgroundColor: getIn(theme.colors, backgroundColor),
  borderRadius: makeBorderSize(theme.border.radius.max),
  maxWidth: makeSize(maxWidth[platform]),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'nowrap',
});

export { getStyledCounterStyles };
